"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IslandErrorBoundary = void 0;
var react_1 = __importDefault(require("react"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var AlertTitle_1 = __importDefault(require("@mui/material/AlertTitle"));
var Box_1 = __importDefault(require("@mui/material/Box"));
/**
 * Keeps one bad field from blanking a whole page.
 *
 * React 18 unmounts the entire tree when a render throws, so an island with no boundary fails by
 * disappearing — which is indistinguishable from a page that loaded nothing. That is exactly how a
 * search box that called a string method on a number turned into "the page goes completely blank",
 * twice, on two different admin screens.
 *
 * Boundaries catch render and lifecycle errors only. A throw inside an event handler or a fetch
 * callback is not caught here and needs its own try/catch — the places that do outcome reporting
 * already have one.
 */
var IslandErrorBoundary = /** @class */ (function (_super) {
    __extends(IslandErrorBoundary, _super);
    function IslandErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { error: null };
        return _this;
    }
    IslandErrorBoundary.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    IslandErrorBoundary.prototype.componentDidCatch = function (error, info) {
        // The component stack is the only thing that names which island failed, and it is not in
        // the Error itself.
        console.error('Island render failed', error, info.componentStack);
    };
    IslandErrorBoundary.prototype.render = function () {
        if (!this.state.error) {
            return this.props.children;
        }
        return (react_1.default.createElement(Box_1.default, { sx: { py: '24px' } },
            react_1.default.createElement(Alert_1.default, { severity: "error", sx: { fontSize: '14px' } },
                react_1.default.createElement(AlertTitle_1.default, { sx: { fontWeight: 700 } }, "This section could not be displayed"),
                "The rest of the page still works. Please tell the web team what you were doing when this appeared.",
                react_1.default.createElement(Box_1.default, { component: "code", sx: {
                        display: 'block', mt: '10px', p: '8px 10px', borderRadius: 1,
                        backgroundColor: 'rgba(0,0,0,0.06)', fontSize: '12px', wordBreak: 'break-word',
                    } }, this.state.error.message))));
    };
    return IslandErrorBoundary;
}(react_1.default.Component));
exports.IslandErrorBoundary = IslandErrorBoundary;
exports.default = IslandErrorBoundary;
